import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'
import { ProtectedElement, withAuth } from '@praxis/component-auth'
import CreateProject from '../containers/Dashboard/CreateProject'
import EditProject from '../containers/Dashboard/EditProject'
import ProjectDetail from '../containers/Dashboard/ProjectDetail'
import {
  adminADGroup,
  artDirectorADGroup,
  generalUserADGroup,
  photographerADGroup,
  producerADGroup,
  retoucherADGroup,
  retouchingLeadADGroup,
  retouchingQAADGroup,
  vendorADGroupProd,
  vendorADGroupStage,
} from '../constants/common'
import ProjectList from '../containers/Dashboard/ProjectList'

const subViewList = {
  dashboard: {
    view: {
      component: ProjectDetail, // TODO: use same for collection wrt Design changes
      name: ':project_name',
      roles: [
        producerADGroup,
        photographerADGroup,
        generalUserADGroup,
        retoucherADGroup,
        retouchingLeadADGroup,
        adminADGroup,
        retouchingQAADGroup,
        artDirectorADGroup,
        vendorADGroupProd,
        vendorADGroupStage,
      ],
    },
    edit: {
      component: EditProject,
      name: 'Edit project',
      roles: [
        producerADGroup,
        photographerADGroup,
        generalUserADGroup,
        retoucherADGroup,
        retouchingLeadADGroup,
        adminADGroup,
        retouchingQAADGroup,
        artDirectorADGroup,
        vendorADGroupProd,
        vendorADGroupStage,
      ],
    },
    create: {
      component: CreateProject,
      name: 'Create Project',
      roles: [
        producerADGroup,
        photographerADGroup,
        generalUserADGroup,
        retoucherADGroup,
        retouchingLeadADGroup,
        adminADGroup,
        retouchingQAADGroup,
        artDirectorADGroup,
        vendorADGroupProd,
        vendorADGroupStage,
      ],
    },
    default: {
      component: ProjectDetail,
      name: ':project_name',
      roles: [
        producerADGroup,
        photographerADGroup,
        generalUserADGroup,
        retoucherADGroup,
        retouchingLeadADGroup,
        adminADGroup,
        retouchingQAADGroup,
        artDirectorADGroup,
        vendorADGroupProd,
        vendorADGroupStage,
      ],
    },
  },
  default: ProjectList,
}
const SubView = (props) => {
  let SubViewPage = subViewList.default
  let { pageName = '', subPageName = '', pageId = '' } = useParams()
  const currentPath = `/${pageName}/${pageId}`?.toString()?.trim('/')
  const curComponentName =
    subViewList[pageName][subPageName]?.name ||
    subViewList[pageName][pageId]?.name ||
    ''
  const currentCustomPath = `/${pageName}/${curComponentName}`
    ?.toString()
    ?.trim('/')
  if (pageName && Object.keys(subViewList).indexOf(pageName) !== -1) {
    SubViewPage =
      subViewList[pageName][subPageName]?.component ||
      subViewList[pageName][pageId]?.component ||
      subViewList[pageName].default?.component
  }
  return (
    <ProtectedElement
      allowed={
        subViewList[pageName]?.[subPageName]?.['roles'] ||
        subViewList[pageName]?.[pageId]?.['roles'] ||
        subViewList[pageName]?.['default']?.['roles']
      }
      render={() => (
        <SubViewPage
          pageName={pageName}
          subPageName={subPageName}
          pageId={pageId}
          {...props}
          customPath={currentCustomPath}
          path={currentPath}
          pathname={currentPath}
        />
      )}
    />
  )
}

SubView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      pageName: PropTypes.string,
      subPageName: PropTypes.string,
      pageId: PropTypes.string,
    }),
  }),
}

const mapAuthToProps = (auth) => {
  return {
    accessToken: auth.session?.userInfo?.accessToken,
    company: auth.session?.userInfo?.company,
    memberOf: auth.session?.userInfo?.memberOf,
    lanId: auth.session?.userInfo?.lanId,
  }
}

export default withAuth(mapAuthToProps)(SubView)
